<template>
  <div>
    <date-range
      :selected-range="selectedPaymentsDateRange"
      @handleSelected="changeSelectedPaymentsDateRange"
    />
    <affiliate-payments-main-table />
  </div>
</template>

<script>
import DateRange from '@/components/dateRanges/DateRange.vue'
import { mapActions, mapGetters } from 'vuex'
import AffiliatePaymentsMainTable from '@/components/affiliate/AffiliatePaymentsMainTable.vue'

export default {
  name: 'AffiliatePaymentsTab',
  components: { AffiliatePaymentsMainTable, DateRange },
  computed: {
    ...mapGetters({
      filters: 'affiliate/paymentsFilters'
    }),
    selectedPaymentsDateRange() {
      return this.filters.paymentsDate
    },
  },
  methods: {
    ...mapActions({
      loadPayments: 'affiliate/loadPayments',
      setPaymentsFilters: 'affiliate/setPaymentsFilters'
    }),
    changeSelectedPaymentsDateRange(date) {
      this.setPaymentsFilters({
        key: 'paymentsDate',
        value: date
      })

      if ((date.value === 'specificDate' && !date.dateFrom) ||
        (date.value === 'range' && (!date.dateFrom || !date.dateTo))
      ) {
        return
      }

      this.loadPayments()
    }
  }
}
</script>
